module.exports = __webpack_public_path__ + "img/h24.89ec4664.svg";